import React, { useEffect } from 'react';
import { Phone } from 'lucide-react';
import ContactForm from '../components/ContactForm';
import { BRAND } from '../mock';
import useReveal from '../hooks/useReveal';

export default function Contact() {
  useReveal();
  useEffect(() => { document.title = 'Contact StreetFleet | Request a Courier Pickup or Quote'; }, []);

  return (
    <>
      <section className="bg-[#4E4E50] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-white">
          <span className="text-[#4FC3E0] font-bold uppercase tracking-wider text-sm">Contact</span>
          <h1 className="text-4xl sm:text-5xl font-extrabold mt-2 mb-4">Let&rsquo;s get it delivered</h1>
          <p className="text-gray-200 text-lg max-w-2xl">Request a pickup, ask for a quote, or set up a business account. For urgent jobs, call <a href={BRAND.phoneHref} className="text-[#4FC3E0] font-bold underline underline-offset-2">{BRAND.phone}</a>.</p>
        </div>
      </section>
      <div className="h-1 bg-gradient-to-r from-[#17A2C4] to-[#4FC3E0]" />

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <ContactForm />
        </div>
      </section>

      <section className="pb-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-100">
            <iframe
              title="StreetFleet location"
              src="https://maps.google.com/maps?q=40%20Toledo%20Crescent%20Thornhill%20Ontario&t=&z=13&ie=UTF8&iwloc=&output=embed"
              className="w-full h-[380px] border-0"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </>
  );
}
